/* A plain modal. The attention-getting is done by the warning banners on the
 * review screens; this dialog is the decision point, so it stays legible and
 * ordinary. The title icon carries the warning colour so it still ties back to
 * the banner that led the controller here. */
const WARNING = "#ED6C02";

export default {
    title: { display: "flex", alignItems: "center", gap: 1 },
    titleIcon: { color: WARNING },
    ask: { mt: 1, fontWeight: 600, color: "text.primary" },
    actions: { px: 3, py: 2 }
};
